export class MailNotificationConfig {
    Id: number;
    UserId: number;
    DeviceId: number;
    NotifyLevel: number;
    UpdatedAt: string;
    CreatedAt: string;
}


export class NotifyAdvanceConfig {
    Id: number;
    EventId: number;
    TerminalId: number;
    OwnerEnabled: boolean;
    TechnicianEnabled: boolean;
    CustomEnabled: boolean;
    CustomRecipient: string;
    Description?: string;
    DefaultDescription?: string;
    Name?: string;

    constructor(EventId: number, TerminalId: number, OwnerEnabled: boolean, TechnicianEnabled: boolean, CustomEnabled: boolean, CustomRecipient: string) {
        this.EventId = EventId;
        this.TerminalId = TerminalId;
        this.OwnerEnabled = OwnerEnabled;
        this.TechnicianEnabled = TechnicianEnabled;
        this.CustomEnabled = CustomEnabled;
        this.CustomRecipient = CustomRecipient;
    }

}
